var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgDevolver(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 19,
    height: 18,
    viewBox: "0 0 19 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M3.47417 17.3709V15.0547H11.6964C12.9123 15.0547 13.9691 14.6687 14.8666 13.8967C15.7641 13.1247 16.2128 12.1596 16.2128 11.0015C16.2128 9.84349 15.7641 8.87844 14.8666 8.1064C13.9691 7.33437 12.9123 6.94835 11.6964 6.94835H4.40062L7.41157 9.9593L5.79029 11.5806L0 5.79029L5.79029 0L7.41157 1.62128L4.40062 4.63223H11.6964C13.5686 4.63223 15.1754 5.24021 16.5168 6.45617C17.8582 7.67213 18.5289 9.18726 18.5289 11.0015C18.5289 12.8158 17.8582 14.331 16.5168 15.5469C15.1754 16.7629 13.5686 17.3709 11.6964 17.3709H3.47417Z",
    fill: "#623232"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDevolver);
export default __webpack_public_path__ + "static/media/devolver.928cd90539af5c9d9c647f02b62d20f1.svg";
export { ForwardRef as ReactComponent };